import { App } from 'vue';
import { captureException, setTag } from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { version } from '../../package.json';
import { networkId } from '@/composables/useNetwork';
import { Network } from 'balancer-labs-sdk-fuji';
import * as Sentry from '@sentry/vue';
import { Router } from 'vue-router';

const ENV = process.env.VUE_APP_ENV || 'development';
const networkMap = {
  [Network.MAINNET]: 'mainnet',
  [Network.KOVAN]: 'kovan',
  [Network.POLYGON]: 'polygon',
  [Network.ARBITRUM]: 'arbitrum-one',
  [Network.FUJI]: 'avalanche-fuji-testnet'
};
const environment = `${ENV}-${networkMap[networkId.value]}`;
const release = `frontend-v2@${version}`;

export default function initSentry(app: App, router: Router) {
  if (['production', 'staging'].includes(ENV)) {
    app.config.errorHandler = (error, _, info) => {
      try {
        setTag('info', info);
        captureException(error, {
          extra: {
            error: error
          }
        });
      } catch (error) {
        console.error('Failed to send error to Sentry', error);
      }
    };

    Sentry.init({
      app,
      dsn:
        'https://19a733ad788f47b9981c905a16b51eba@o1157109.ingest.sentry.io/6239226',
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router)
        })
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      environment,
      release
    });
  }
}
